<template>
  <nav class="breadcrumb" aria-label="Breadcrumb">
    <router-link class="breadcrumb-link" to="/">Home</router-link>
    <span class="breadcrumb-separator">/</span>
    <template v-for="item in parents">
      <router-link :key="item.to" class="breadcrumb-link" :to="item.to">
        {{ item.label }}
      </router-link>
      <span :key="item.to + '-separator'" class="breadcrumb-separator">/</span>
    </template>
    <span class="breadcrumb-current">{{ currentLabel }}</span>
  </nav>
</template>

<script>
export default {
  name: 'Breadcrumb',
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  computed: {
    parents() {
      return this.$route.meta.breadcrumb || [];
    },
    currentLabel() {
      return this.title || this.$route.meta.breadcrumbTitle || this.$route.meta.title || 'Current Page';
    },
  },
};
</script>

<style lang="scss" scoped>
.breadcrumb {
  width: 100%;
  max-width: 1000px;
  margin: 18px auto 0;
  padding: 0 20px;
  color: #6b7280;
  font-size: 14px;
  line-height: 22px;
}

.breadcrumb-link {
  color: #1a5881;
  text-decoration: none;

  &:hover {
    color: #2880ba;
    text-decoration: underline;
    text-underline-offset: 2px;
  }
}

.breadcrumb-separator {
  display: inline-block;
  margin: 0 8px;
  color: #9ca3af;
}

.breadcrumb-current {
  color: #374151;
}

@media (max-width: 768px) {
  .breadcrumb {
    margin-top: 12px;
    padding: 0 15px;
  }
}
</style>
